// CommfluentBiz Mock Data

export const siteConfig = {
  name: "CommfluentBiz",
  tagline: "Speak with Power. Influence with Purpose.",
  logo: "https://customer-assets.emergentagent.com/job_commfluent/artifacts/zgbrvj8y_commpic.png"
};

export const heroContent = {
  headline: "Become a Magnetic Communicator",
  subheadline: "Communication isn't a soft skill, it's your ultimate power move. CommfluentBiz empowers ambitious professionals to speak with clarity, confidence, and influence where it matters most.",
  tagline: "You're one conversation away from bigger deals, stronger authority, and real impact.",
  primaryCta: "Book a Free Strategy Call",
  secondaryCta: "Explore Our Programs",
  calendlyUrl: "https://calendly.com/commfluentbizcom/30min"
};

export const socialProofLogos = [];

export const whyCommunicationContent = {
  headline: "Your Skills Open Doors. Your Communication Decides How Far You Go.",
  subheadline: "Learn once. Practice daily. Improve instantly with AI-powered feedback.",
  points: [
    {
      title: "Rise to the Top",
      description: "Promotions don't go to the smartest, they go to the most influential communicators who can articulate value and inspire teams."
    },
    {
      title: "Ideas That Land",
      description: "Great ideas fail when they aren't communicated powerfully. Learn to present concepts that stick and move people to action."
    },
    {
      title: "Lead with Presence",
      description: "Leadership starts with how you speak, listen, and show up. Master the art of executive presence that commands respect."
    },
    {
      title: "Influential Blue Print System",
      description: "A clear, repeatable system for how someone creates influence their mindset, behavior, communication style and presence."
    }
  ]
};

export const frameworkContent = {
  headline: "The Magnetic Communicator Framework",
  subheadline: "The Science, Strategy & Presence Behind Influential Communication",
  pillars: [
    {
      name: "Clarity",
      icon: "Target",
      description: "Structure your thoughts so people instantly get you. Cut through noise with precision messaging."
    },
    {
      name: "Presence",
      icon: "Sparkles",
      description: "Command attention without forcing it. Develop the gravitas that makes people lean in."
    },
    {
      name: "Story",
      icon: "BookOpen",
      description: "Turn ideas into memorable narratives. Connect emotionally and make your message unforgettable."
    },
    {
      name: "Voice & Delivery",
      icon: "Mic",
      description: "Use tone, pace, and strategic silence. Master the instrument of your voice."
    },
    {
      name: "Influence",
      icon: "Users",
      description: "Move people to action ethically and authentically. Build lasting trust and credibility."
    }
  ]
};

export const programsContent = {
  headline: "Transform Your Communication",
  subheadline: "Comprehensive programs designed for ambitious professionals and forward-thinking organizations",
  individuals: {
    title: "For Individuals",
    programs: [
      {
        name: "Magnetic Communication Mastery",
        duration: "Custom",
        description: "Complete transformation program covering all 5 pillars of magnetic communication. Sales, negotiation, Influence Training. AI-Era Leadership Skills.",
        highlight: "Most Popular"
      },
      {
        name: "Executive Presence Accelerator",
        duration: "4 Weeks",
        description: "Intensive program for emerging leaders ready to command any room.",
        highlight: null
      },
      {
        name: "Confident Speaking for Career Growth",
        duration: "4 Weeks",
        description: "Master presentations, pitches, and high-stakes conversations.",
        highlight: null
      }
    ]
  },
  businesses: {
    title: "For Businesses & Teams",
    programs: [
      {
        name: "Corporate Communication Excellence",
        duration: "Custom",
        description: "Learn AI-Era Leadership Skills",
        subDescription: "Master the essential leadership capabilities required to lead high-performing teams in the AI era",
        highlight: "Enterprise"
      },
      {
        name: "Leadership Communication Bootcamp",
        duration: "2 Days",
        description: "Intensive workshop for leadership teams to align and amplify.",
        highlight: null
      },
      {
        name: "Sales & Influence Training",
        duration: "3 Days",
        description: "Equip your sales team with persuasion and influence mastery.",
        highlight: null
      }
    ]
  }
};

export const influenceLabContent = {
  headline: "Influence Lab",
  subheadline: "From Professional to Influencer in Your Industry",
  features: [
    "Build a strong personal brand that attracts opportunities",
    "Communicate authority on camera and stage with confidence",
    "Create content that positions you as a trusted voice",
    "Stay relevant and ahead of the curve in your industry"
  ]
};

export const testimonialsContent = {
  headline: "Real Confidence. Real Influence. Real Growth.",
  testimonials: [
    {
      quote: "CommfluentBiz transformed how I present to the board. I went from nervous to commanding. My last presentation led to a promotion.",
      name: "Sarah Chen",
      role: "VP of Marketing",
      company: "Tech Fortune 500"
    },
    {
      quote: "The Magnetic Communicator Framework gave me a complete system. I now close 40% more deals because I can truly connect with clients.",
      name: "Michael Adebayo",
      role: "Sales Director",
      company: "SaaS Startup"
    },
    {
      quote: "As an introvert, I thought powerful communication wasn't for me. CommfluentBiz showed me authentic influence that feels natural.",
      name: "Jessica Martinez",
      role: "Founder & CEO",
      company: "Consulting Firm"
    },
    {
      quote: "Our entire leadership team went through the bootcamp. The alignment and clarity we achieved was worth 10x the investment.",
      name: "David Park",
      role: "COO",
      company: "Healthcare Company"
    }
  ]
};

export const finalCtaContent = {
  headline: "Your Voice Is Your Greatest Asset. Train It.",
  subheadline: "Ready to become the communicator you've always admired? Let's start with a conversation.",
  primaryCta: "Book a Free Strategy Call",
  secondaryCta: "",
  calendlyUrl: "https://calendly.com/commfluentbizcom/30min"
};

export const footerContent = {
  description: "CommfluentBiz helps professionals become magnetic communicators who influence, lead, and grow their careers or businesses.",
  quickLinks: [
    { name: "About", href: "#about" },
    { name: "Programs", href: "#programs" }
  ],
  programs: [
    { name: "Communication Mastery", href: "#" },
    { name: "Executive Presence", href: "#" },
    { name: "Corporate Training", href: "#" }
  ],
  social: [
    { name: "LinkedIn", href: "https://www.linkedin.com/company/commfluentbiz/" },
    { name: "Instagram", href: "https://www.instagram.com/commfluentbiz/" }
  ],
  contact: {
    email: "commfluentbizcom@gmail.com",
    phone: "+919513151980",
    location: "Bangalore, India"
  }
};

export const navItems = [
  { name: "About", href: "#about" },
  { name: "Framework", href: "#framework" },
  { name: "Programs", href: "#programs" }
];
